import { render, staticRenderFns } from "./depotList.vue?vue&type=template&id=2781f73a&scoped=true&"
import script from "./depotList.vue?vue&type=script&lang=js&"
export * from "./depotList.vue?vue&type=script&lang=js&"
import style0 from "./depotList.vue?vue&type=style&index=0&id=2781f73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781f73a",
  null
  
)

component.options.__file = "depotList.vue"
export default component.exports